import 'focus-visible';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange'; // tslint:disable-line
import 'lazysizes/plugins/respimg/ls.respimg'; // tslint:disable-line
import 'lazysizes/plugins/rias/ls.rias'; // tslint:disable-line

import '../../styles/theme.pcss';

import {CartLink} from '../ui/cart-link';
import '../ui/cart-link/cart-link.pcss';

import {Dropdown} from '../ui/dropdown';
import '../ui/dropdown/dropdown.pcss';

import {Navigation} from '../ui/navigation';
import '../ui/navigation/navigation.pcss';

import {MobileNavigation} from '../ui/mobile-navigation';
import '../ui/mobile-navigation/navigation.pcss';

import {ProductCard} from '../ui/product-card';
import '../ui/product-card/product-card.pcss';

import {PlusMinus} from '../ui/plus-minus';
import '../ui/plus-minus/plus-minus.pcss';

import {SearchBox} from '../ui/search-box';
import '../ui/search-box/search-box.pcss';

import {Modal} from '../ui/modal';
import '../ui/modal/modal.pcss';

import {cookiesEnabled, mountReact, ready} from '../utils';

import {Accordion} from '../ui/accordion';
import {Cart} from '../ui/cart';
import {CookieBar} from '../ui/cookie-bar';
import {GalleryMobileSliderDesktopScroller} from '../ui/gallery-mobile-slider-desktop-scroller';
import {MessageGroup} from '../ui/message-group';
import {ProductTabs} from '../ui/product-tabs';
import {TradeBar} from './../ui/trade-bar';
import {Usp} from './../ui/usp';

import {HomepageAlert} from '../ui/honempage-alert/homepage-alert';

import '../ui/drawer';

if (!cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-cookies',
    'supports-no-cookies',
  );
}

const nav = document.querySelector('[data-navigation]') as HTMLElement;
new Navigation(nav);

new MobileNavigation();

const usp = document.getElementById('usp-banner') as HTMLElement;
if (usp) {
  new Usp();
}

const gallery = document.querySelector('[data-gallery-slider]') as HTMLElement;
if (gallery) {
  new GalleryMobileSliderDesktopScroller();
}

new ProductCard();

Array.from(document.querySelectorAll(CartLink.defaults.selector)).map(
  item => new CartLink(item as HTMLElement),
);

Array.from(document.querySelectorAll('[data-footer-accordion]')).map(
  item => new Accordion(item as HTMLElement, {}),
);

Array.from(document.querySelectorAll(Dropdown.defaults.selector)).map(
  item => new Dropdown(item as HTMLElement),
);

Array.from(document.querySelectorAll(PlusMinus.defaults.selector)).map(
  item => new PlusMinus(item as HTMLElement),
);

Array.from(document.querySelectorAll(SearchBox.defaults.selector)).map(
  item => new SearchBox(item as HTMLElement),
);

Array.from(document.querySelectorAll(Modal.defaults.modalSelector)).map(
  item => new Modal(item as HTMLElement),
);

const productTabs = document.getElementById('productTabs') as HTMLElement;
if (productTabs) {
  new ProductTabs(productTabs, {firstItemOpen: true});
}

mountReact('#message-group', MessageGroup);
mountReact('#cookie-bar', CookieBar);
mountReact('#trade-bar', TradeBar);
mountReact('#mini-cart', Cart);
mountReact('#homepage-alert', HomepageAlert);

/**
 * DOM loaded decorator for animation fix
 */
const removePreload = () => document.body.classList.remove('preload');

ready(removePreload);

/**
 * Decorate lazy load parents
 * @param {Event} event
 */
function decorateLazyParent(event: Event) {
  const target = event.target as HTMLElement;
  const wrapper = target.closest('.responsive-image__wrapper');

  if (!wrapper) {
    return;
  }

  wrapper.classList.add('has-loaded');
}

document.addEventListener('lazyloaded', decorateLazyParent);

declare global {
  interface Window {
    theme: {
      moneyFormat: string;
      cart_qty: number;
    };
  }
}
